export default __webpack_public_path__ + "static/media/hombre-silueta.7d04994e.png";